import request from '@/utils/bbs_request.js'
// WabFind页面
export function findDate(params) {
  return request({
    url: '/group/group/getGroupListByCategoryID',
    methods: 'get',
    params
  })
}
// WabFind页面关注接口
export function attendGroup(params) {
  return request({
    url: '/user/user/attendGroup',
    methods: 'get',
    params
  })
}
// WabFind页面取消关注接口
export function removeGroup(params) {
  return request({
    url: '/user/user/removeGroup',
    methods: 'get',
    params
  })
}
// WabFind页面一级分类接口
export function categorywDate(params) {
  return request({
    url: '/group/classify/getClassifyForWap',
    methods: 'get',
    params
  })
}
